/**
 * Stepper control. Two layouts:
 *   - default: [−] value [+]
 *   - stacked: value with [+] / [−] buttons stacked vertically on the right
 */
export default function Stepper({
  value, onChange, min, max, step, stacked = false,
}: {
  value: number; onChange: (v: number) => void; min: number; max: number; step: number;
  stacked?: boolean;
}) {
  const dec = () => onChange(Math.max(min, value - step));
  const inc = () => onChange(Math.min(max, value + step));
  if (stacked) {
    return (
      <div className="malpedia-rag-stepper malpedia-rag-stepper-stacked">
        <span className="malpedia-rag-stepper-value">{value}</span>
        <div className="malpedia-rag-stepper-buttons">
          <button type="button" onClick={inc} aria-label="Increment">▲</button>
          <button type="button" onClick={dec} aria-label="Decrement">▼</button>
        </div>
      </div>
    );
  }
  return (
    <div className="malpedia-rag-stepper">
      <button type="button" onClick={dec}>−</button>
      <span className="malpedia-rag-stepper-value">{value}</span>
      <button type="button" onClick={inc}>+</button>
    </div>
  );
}
